import React, { createContext, useContext, useState } from "react";
import { Dayjs } from "dayjs";

type TripType = "0" | "1"; // Adjust as needed

interface FlightSearchState {
  origin: string;
  setOrigin: (val: string) => void;
  destination: string;
  originCode: string;
  setOriginCode: (val: string) => void;
  destinationCode: string;
  setDestinationCode: (val: string) => void;
  setDestination: (val: string) => void;
  fromDate: string | null;
  setFromDate: (val: string | null) => void;
  toDate: string | null;
  setToDate: (val: string | null) => void;
  tripType: TripType;
  setTripType: (val: TripType) => void;
  adult: number;
  setAdult: (val: number) => void;
  child: number;
  setChild: (val: number) => void;
  infant: number;
  setInfant: (val: number) => void;
  cabin: number;
  setCabin: (val: number) => void;
}

const FlightSearchContext = createContext<FlightSearchState | undefined>(
  undefined
);

export const FlightSearchProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [origin, setOrigin] = useState<string>("");
  const [destination, setDestination] = useState<string>("");
  const [fromDate, setFromDate] = useState<string | null>(null);
  const [toDate, setToDate] = useState<string | null>(null);
  const [tripType, setTripType] = useState<TripType>("0");
  const [adult, setAdult] = useState<number>(1);
  const [child, setChild] = useState<number>(0);
  const [infant, setInfant] = useState<number>(0);
  const [originCode, setOriginCode] = useState<string>("");
  const [destinationCode, setDestinationCode] = useState<string>("");
  const [cabin, setCabin] = useState<number>(0);
  return (
    <FlightSearchContext.Provider
      value={{
        cabin,
        setCabin,
        destinationCode,
        originCode,
        setDestinationCode,
        setOriginCode,
        origin,
        setOrigin,
        destination,
        setDestination,
        fromDate,
        setFromDate,
        toDate,
        setToDate,
        tripType,
        setTripType,
        adult,
        setAdult,
        child,
        setChild,
        infant,
        setInfant,
      }}
    >
      {children}
    </FlightSearchContext.Provider>
  );
};

export const useFlightSearch = () => {
  const context = useContext(FlightSearchContext);
  if (!context) {
    throw new Error(
      "useFlightSearch must be used within a FlightSearchProvider"
    );
  }
  return context;
};
